import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { GenerateTokenIcon } from "../../../../shared/icons/GenerateTokenIcon";
import { AppButton } from "../../../../shared/components/AppButton";
import styles from "../../styles.module.css";

interface Props {
  openCreateStatic: () => void;
  className?: string;
}

export const StaticTokenButton = (props: Props) => {
  const { t } = useTranslation();
  return (
    <AppButton
      buttonType={"text"}
      icon={<GenerateTokenIcon />}
      onClick={props.openCreateStatic}
      className={classNames(
        styles.button,
        styles["ask-gpt-button"],
        props.className,
      )}
    >
      {t("common.static_token_button")}
    </AppButton>
  );
};
